export const extractLastChar = (value: string, amount: number) =>
  value.substring(value.length - amount);

export const extractFirstChar = (value: string, amount: number) =>
  value.substring(0, amount);

export const isValidIban = (rawIban: string) => {
  const ibanRegex =
    /^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/;
  return ibanRegex.test(rawIban);
};

export function isValidEmail(email: string) {
  const re =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return re.test(email);
}

export const ethereumWalletRegex = /^(0x)?[0-9a-fA-F]{40}$/;

// export const formatDollarAmount = (amount, opt = {}) => {
//   return Number(amount).toLocaleString('en-US', {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: opt.maximumFractionDigits || 5,
//   });
// };

export const formatDollarAmount = (
  amount: string,
  opt: { maximumFractionDigits?: number } = {}
) => {
  return Number(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: opt.maximumFractionDigits || 5,
  });
};

export function validateUSRoutingNumber(routingNumber: string): boolean {
  // Routing numbers must be exactly 9 digits
  if (routingNumber.length !== 9) {
    return false;
  }

  // Calculate checksum using ABA routing number algorithm
  // Each digit is multiplied by a weighting factor
  // The weighting factors are 3,7,1,3,7,1,3,7,1 from left to right
  const weights = [3, 7, 1, 3, 7, 1, 3, 7, 1];

  const sum = routingNumber.split('').reduce((acc, digit, idx) => {
    return acc + parseInt(digit) * weights[idx];
  }, 0);

  // Sum must be divisible by 10 for the routing number to be valid
  return sum % 10 === 0;
}

export function validateUSAccountNumber(
  accountNumber: string,
  options: { minLength?: number; maxLength?: number } = {}
): boolean {
  const { minLength = 4, maxLength = 17 } = options;

  // Check length constraints
  if (accountNumber.length < minLength || accountNumber.length > maxLength) {
    return false;
  }

  // Must contain only numbers
  if (!/^\d+$/.test(accountNumber)) {
    return false;
  }

  // Check for obviously invalid patterns
  const invalidPatterns = [
    /^0+$/, // All zeros
    /^1{4,}/, // Four or more consecutive 1's at start
    /(.)\1{5,}/, // Same digit repeated 6 or more times
  ];

  for (const pattern of invalidPatterns) {
    if (pattern.test(accountNumber)) {
      return false;
    }
  }

  return true;
}
